<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToWaitlist = () => {
  if (router.currentRoute.value.name !== 'home') {
    router.push({ name: 'home', hash: '#waitlist' })
  } else {
    document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<template>
  <section id="hero" class="relative min-h-screen flex items-center pt-20">
    <div class="absolute inset-0 -z-10" style="background: linear-gradient(135deg, var(--color-krate-blue-50), white, var(--color-krate-blue-50));"></div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
      <div class="grid grid-cols-1 lg:grid-cols-5 gap-6 items-center">
        <div class="lg:col-span-3 text-center lg:text-left">
          <h1 class="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight" style="color: var(--color-krate-dark-900);">
            Run devcontainers
            <span style="color: var(--color-krate-blue-600);">without Docker</span>.
          </h1>

          <p class="mt-6 text-xl md:text-2xl max-w-3xl mx-auto lg:mx-0" style="color: var(--color-krate-dark-600);">
            krate boots workloads in their own microVMs. 100% <code style="font-family: var(--font-mono); background: var(--color-krate-dark-100); padding: 2px 8px; border-radius: 4px; font-size: 0.85em;">.devcontainer</code> compatible. <span style="color: var(--color-krate-blue-600); font-weight: 600;">No Docker daemon required.</span>
          </p>

          <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
            <button @click="goToWaitlist" data-umami-event="cta-hero-beta" class="text-lg font-semibold px-8 py-4 rounded-lg transition-transform hover:scale-105" style="background-color: var(--color-krate-blue-600); color: white;">
              Join the beta
            </button>
            <a href="https://github.com/krate-dot-sh" target="_blank" rel="noopener" data-umami-event="cta-hero-github" class="text-lg font-semibold px-8 py-4 rounded-lg border-2 inline-block text-center" style="border-color: var(--color-krate-dark-200); color: var(--color-krate-dark-900);">
              View on GitHub
            </a>
          </div>

        </div>

        <div class="lg:col-span-2 flex justify-center lg:justify-start">
          <img src="/img/logo.svg" alt="A kernel-isolated krate — a stylized metal crate with a shield-shaped lock" class="w-full max-w-md lg:max-w-lg xl:max-w-xl h-auto" loading="eager" />
        </div>
      </div>
    </div>
  </section>
</template>
